var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-button",on:{"click":function($event){return _vm.$_downloadClick(_vm.url, _vm.fileName)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }